import { validateEmail } from '@Helper/utils';
import React, { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import './TagInput.scss';

type IProps = {
  defaultValues: string[];
  setValue: (tag: string[]) => void;
  type: 'text' | 'email';
  placeholder: string;
};

const TagInput: FC<IProps> = ({
  setValue,
  defaultValues,
  type,
  placeholder,
}) => {
  const [input, setInput] = useState<string>('');
  const [isKeyReleased, setIsKeyReleased] = useState<boolean>(false);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const lastChar = value.substring(value.length - 1);
    if (lastChar === ',') {
      EnterInput(
        value.substring(0, value.length - 1),
        defaultValues,
        setValue,
        setInput
      );
      return;
    }

    setInput(value);
  };

  const onBlur = (e: any) => {
    const trimmedInput = input.trim();

    e.preventDefault();
    if (type === 'email') {
      EnterInput(trimmedInput, defaultValues, setValue, setInput);

      return;
    }
    const tags = [...defaultValues, trimmedInput] as string[];
    setValue(tags);
    setInput('');
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const { key } = e;
    const trimmedInput = input.trim();

    if (
      key === 'Enter' &&
      trimmedInput.length &&
      !defaultValues.includes(trimmedInput)
    ) {
      e.preventDefault();
      if (type === 'email') {
        EnterInput(trimmedInput, defaultValues, setValue, setInput);

        return;
      }
      const tags = [...defaultValues, trimmedInput] as string[];
      setValue(tags);
      setInput('');
    }

    if (
      key === 'Backspace' &&
      !input.length &&
      defaultValues.length &&
      isKeyReleased
    ) {
      const tagsCopy = [...defaultValues];
      const poppedTag = tagsCopy.pop();
      e.preventDefault();
      setValue(tagsCopy);
      setInput(poppedTag || '');
    }

    setIsKeyReleased(false);
  };

  const onKeyUp = () => {
    setIsKeyReleased(true);
  };

  const deleteTag = (index: number) => {
    const tags = defaultValues.filter((tag, i) => i !== index);
    setValue(tags);
    setInput('');
  };

  return (
    <div className="wapper-tag-input">
      {defaultValues.map((tag, index) => (
        <div className="tag" key={index}>
          {tag}
          <button onClick={() => deleteTag(index)}>x</button>
        </div>
      ))}
      <input
        value={input}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onBlur={onBlur}
      />
    </div>
  );
};

export default TagInput;
function EnterInput(
  trimmedInput: string,
  defaultValues: string[],
  setValue: (tag: string[]) => void,
  setInput: React.Dispatch<React.SetStateAction<string>>
) {
  if (validateEmail(trimmedInput)) {
    const tags = [...defaultValues, trimmedInput] as string[];
    setValue(tags);
    setInput('');
  } else {
    if (trimmedInput !== '') {
      toast.error('Email is not available', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    }
  }
}
